import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { landingPageRoute } from '../../common/linkRoutes';
import { useStore } from '../../store/store';
import Messages from '../messages/Messages';
import Topbar, { TopbarProps } from '../topbar/Topbar';
import './layout.css';

export type LayoutProps = TopbarProps & {
  hideTopbar?: Boolean;
  pageName: String;
  children: React.ReactNode;
  location: Location;
  history: RouteComponentProps['history'];
};

const Layout = (props: LayoutProps) => {
  const { user, isLoading, redirect, messages, resetRedirect } = useStore();

  useEffect(() => {
    window.scroll(0, 0);
  }, [isLoading, messages]);

  useEffect(() => {
    if (redirect && redirect !== '' && props.location.pathname !== redirect) {
      props.history.push(redirect);
      resetRedirect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [redirect]);

  if (!user && props.location.pathname !== '/') {
    props.history.push(landingPageRoute);
  }

  //   if (redirect && redirect !== '' && props.location.pathname !== redirect) {
  //     // props.history.push(redirect);
  //     resetRedirect();
  //     return <Redirect to={redirect} />;
  //   }

  return (
    <>
      {!props.hideTopbar ? <Topbar {...props} /> : null}
      <div className={`layout ${props.hideTopbar ? 'no-topbar' : ''}`}>
        {isLoading && <span>Looooading!!</span>}

        <Messages />

        {props.children}
      </div>
    </>
  );
};

export default Layout;
